import { createApi } from '@redux/createApi';

export const quickSearchApi = createApi({
  reducerPath: 'quickSearchApi',
  tagTypes: ['QuickSearch'],
  endpoints: (builder) => ({
    getUserByWallet: builder.query({
      query: (walletAddress) => ({
        method: 'get',
        url: `/admin/report/user/${encodeURIComponent(walletAddress)}`,
      }),
    }),
    getConversionByTxId: builder.query({
      query: (txId) => ({
        method: 'get',
        url: `/admin/report/convertion/${encodeURIComponent(txId)}`,
      }),
    }),
  }),
});

export const { useGetUserByWalletQuery, useGetConversionByTxIdQuery } = quickSearchApi;
